import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { DetailCard } from '../../../components/detail-card.component';
import PlusMinusNumberInput from '../../../components/plus-minus-number-input/plus-minus-number-input.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import { useReplenishDetail } from './replenish-detail.controller';

export const ReplenishDetail = () => {
    const viewProps = useReplenishDetail();

    if (!viewProps.replenishment) {
        return (
            <WizardScreenContainer>
                <div className='flex h-full w-full items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-12' />
                </div>
            </WizardScreenContainer>
        );
    }

    return (
        <WizardScreenContainer
            footer={{ onBack: viewProps.onBack, onSubmit: () => viewProps.replenish(), submitDisabled: viewProps.amount === null || viewProps.amount <= 0 }}>
            <div className='inline-flex flex-col items-start justify-start gap-3 self-stretch'>
                <div className='flex w-full justify-between'>
                    <span className='text-foreground-default justify-center text-base font-medium'>
                        <FormattedMessage
                            defaultMessage='Selected product'
                            id='confirm-lending.selected-product'
                        />
                    </span>
                </div>
                <div className='inline-flex flex-col items-start justify-start gap-2 self-stretch'>
                    <ProductCard
                        product={viewProps.replenishment.product}
                        variant='stock'
                        fill_amount={viewProps.replenishment.proposed_max}
                        current_stock={viewProps.replenishment.quantity}
                        min_stock={viewProps.replenishment.required_min}
                        max_stock={viewProps.replenishment.required_max}
                    />
                    <DetailCard>
                        <DetailCard.Row
                            label={CommonMessage.OBJECTS.PRODUCT.EAN}
                            value={viewProps.replenishment.product.ean || 'N/A'}
                        />
                        <DetailCard.Row
                            label={CommonMessage.OBJECTS.PRODUCT.SKU}
                            value={viewProps.replenishment.product.sku || 'N/A'}
                        />
                        <DetailCard.Separator />
                        <DetailCard.Row
                            label={CommonMessage.OBJECTS.STOCK.CURRENT_STOCK}
                            value={viewProps.replenishment.quantity.toString()}
                        />
                        <DetailCard.Row
                            label={CommonMessage.OBJECTS.STOCK.MIN_STOCK}
                            value={viewProps.replenishment.required_min.toString()}
                        />
                        <DetailCard.Row
                            label={CommonMessage.OBJECTS.STOCK.MAX_STOCK}
                            value={viewProps.replenishment.required_max.toString()}
                        />
                    </DetailCard>
                </div>
                <div className='inline-flex flex-col items-start justify-start gap-3 self-stretch'>
                    <div className='text-foreground-default w-full justify-end text-base font-medium'>
                        <FormattedMessage
                            defaultMessage='Fill amount'
                            id='replenish-overview.fill-amount'
                        />
                    </div>
                    {viewProps.amount === null ? (
                        <Spinner />
                    ) : (
                        <PlusMinusNumberInput
                            min={1}
                            max={viewProps.getMaxAmount()}
                            increment={viewProps.replenishment.fill_increment}
                            value={viewProps.amount}
                            onChange={viewProps.setAmount}
                        />
                    )}
                </div>
            </div>
        </WizardScreenContainer>
    );
};
